import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { partnerService } from '@app/core/services/partner.service';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-month-report-editor',
  templateUrl: './month-report-editor.component.html',
  styleUrls: ['./month-report-editor.component.css'],
})
export class MonthReportEditorComponent implements OnInit {
  activeUser: any;
  backLink!: string;
  filterForm!: FormGroup;
  page!: any;
  listArticles: any;
  topTen: any;
  monthName: any;
  myDate = new Date();
  monthSummary: any;
  mes: any;
  anio: any;
  filterHistorical!: FormGroup;
  yearHist: any;
  currentYear: any;
  acumPagesView = 0;
  years: any[] = [];
  months = [
    {},
    { index: 0, value: 1, month: 'Enero' },
    { index: 1, value: 2, month: 'Febrero' },
    { index: 2, value: 3, month: 'Marzo' },
    { index: 3, value: 4, month: 'Abril' },
    { index: 4, value: 5, month: 'Mayo' },
    { index: 5, value: 6, month: 'Junio' },
    { index: 6, value: 7, month: 'Julio' },
    { index: 7, value: 8, month: 'Agosto' },
    { index: 8, value: 9, month: 'Septiembre' },
    { index: 9, value: 10, month: 'Octubre' },
    { index: 10, value: 11, month: 'Noviembre' },
    { index: 11, value: 12, month: 'Diciembre' },
  ];

  constructor(private partnerService: partnerService) {}

  ngOnInit(): void {
    this.generateYears();

    this.activeUser = JSON.parse(sessionStorage.getItem('user') || '{}');
    this.activeUser = JSON.parse(sessionStorage.getItem('user') || '{}');
    //console.log(this.months.length);
    if (this.activeUser.user) {
      this.activeUser = this.activeUser.user;
    }

    //Devolver al dashboard correspondiente
    switch (this.activeUser.account_type) {
      case 'automatic':
        this.backLink = '/rss-dashboard';
        break;
      case 'manual':
        this.backLink = '/cms-dashboard';
        break;
      case 'trial':
        this.backLink = '/trial-dashboard';
        break;
      case 'redaccion':
        this.backLink = '/editor-dashboard';
        break;
      default:
        this.backLink = '/hybrid-dashboard';
        break;
    }

    //Form resumen mes
    this.filterForm = new FormGroup({
      email: new FormControl(this.activeUser.email),
      month: new FormControl(''),
      year: new FormControl(''),
      page: new FormControl(''),
    });

    //Form historico gráficas
    this.filterHistorical = new FormGroup({
      yearHist: new FormControl(''),
    });

    this.currentYear = this.myDate.getUTCFullYear();

    //Trae el mes anterior
    this.anio = this.myDate.getFullYear();
    this.mes = this.myDate.getMonth();
    this.monthName = this.myDate.getMonth();

    if (this.monthName === -1) {
      this.monthName = 12;
      this.anio = 2022;
      this.mes = 12;
    }

    this.monthSummary = this.months[this.monthName].month;

    // console.log('mes', this.mes);
    // console.log('monthName', this.monthName);
    // console.log('months-indice', this.months[this.monthName].index);
    // console.log('monthSummary', this.monthSummary);

    this.submitFormFilter();
  }

  submitFormFilter() {
    const request = {
      email: this.activeUser.email,
      month: this.filterForm.value.month,
      year: this.filterForm.value.year,
      page: this.filterForm.value.page,
    };
    //console.log('Año', request.year);
    if (request.month > 0) {
      this.monthSummary = this.months[request.month].month;
    } else if (request.month === '') {
      request.month = this.myDate.getMonth();

      if (request.month === -1) {
        request.month = 12;
        request.year = this.myDate.getFullYear() - 1;
      }

      this.monthSummary = this.months[request.month].month;
    }

    //console.log(request.month);
    this.getArticleProfitFilter(request);
    return request;
  }

  placeDecimal(value: number) {
    return value
      .toFixed(0)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  getArticleProfitFilter(request: any) {
    const list$: Observable<any> = this.partnerService.getArticleProfit(request);
    list$.subscribe((response) => {
      this.listArticles = response.page.articles;
      this.topTen = response.page.topArticles;

      //console.log('list', response);
      //Suma total páginas vistas
      /*for (let i = 0; i < this.listArticles.length; i++) {
        this.acumPagesView = this.acumPagesView + parseFloat(this.listArticles[i]['Pageviews']);
        //console.log('suma', this.acumPagesView);
      }*/
      if (this.listArticles == '') {
        Swal.fire('', 'No cuenta con información este mes', 'warning');
      }

      this.page = {
        initial_item: response.page.initial_item,
        end_item: response.page.end_item,
        page: response.page.page,
        total_register: response.page.total_register,
      };
    });
  }

  pagination(pag: number) {
    const request = {
      email: this.activeUser.email,
      month: this.filterForm.value.month,
      year: this.filterForm.value.year,
      page: pag,
    };
    this.getArticleProfitFilter(request);
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    const startYear = 2022; // o el año desde donde quieres iniciar
    this.years = [];
    for (let year = startYear; year <= currentYear; year++) {
      this.years.push({
        value: year,
        year: year.toString(),
      });
    }
  }

  submitFilterHistorical() {
    this.yearHist = this.filterHistorical.value.yearHist;

    //console.log('subYear', this.yearHist);
  }
}
